;!function(){try{var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { Container } from '@/components/ui/container'
import { Heading } from '@/components/ui/heading'
import { Text } from '@/components/ui/text'
import { clsx } from 'clsx/lite'
import type { ComponentProps, ReactNode } from 'react'

export function HeroSimpleCentered({
  eyebrow,
  headline,
  subheadline,
  cta,
  className,
  ...props
}: {
  eyebrow?: ReactNode
  headline: ReactNode
  subheadline: ReactNode
  cta?: ReactNode
} & ComponentProps<'section'>) {
  return (
    <section className={clsx('py-16', className)} {...props} data-sentry-component="HeroSimpleCentered" data-sentry-source-file="hero-simple-centered.tsx">
      <Container className="flex flex-col items-center gap-6" data-sentry-element="Container" data-sentry-source-file="hero-simple-centered.tsx">
        {eyebrow}
        <Heading className="max-w-5xl text-center" data-sentry-element="Heading" data-sentry-source-file="hero-simple-centered.tsx">{headline}</Heading>
        <Text size="lg" className="flex max-w-xl flex-col gap-4 text-center" data-sentry-element="Text" data-sentry-source-file="hero-simple-centered.tsx">
          {subheadline}
        </Text>
        {cta}
      </Container>
    </section>
  )
}
